import { GridContainer, GridWrapper, ZoneB, ZoneC } from "../../App/Pages/styles/Grid.styled";
import React from "react";
import styled from "styled-components";
import { useState } from "react";
import query from "../../../server/constants.api";
import { useEffect } from "react";
import renderComponent from "../../../utils/serializers/renderComponent";
import useMultipleFetch from "../../../server/useMultipleFetch";
import { useConfigContext } from "../../../contexts/ConfigContext";

const ZoneA = styled.div`
  grid-column: col1;
  grid-row: 1 / -1;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: ${props => (props.rows ? props.rows : '0.5fr 0.5fr 2fr 1fr')};
  /* max-height: 100vh; */
`;

const ZoneD = styled.div`
  grid-column: col3;
  grid-row: 1 / -1;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: ${props => (props.rows ? props.rows : '1fr 1fr 2fr 1fr')};
  max-height: 100vh;
`;

const LayoutDefault = () => {
  // const { data, isLoading } = useFetch(query.path.layoutZonaA, 'getLayoutZonaA');
  const { currentConfig } = useConfigContext();

  const queryResults = useMultipleFetch([
    { path: query.path.layoutZonaA, id: 'getLayoutZonaA' },
    { path: query.path.layoutZonaB, id: 'getLayoutZonaB' },
    { path: query.path.layoutZonaC, id: 'getLayoutZonaC' }
    // {path: query.path.layoutZonaD, id: 'getLayoutZonaD'}
  ]);

  const [layoutAData, setLayoutAData] = useState(null);
  const [forZonaAFr, setForZonaAFr] = useState(null);

  const [layoutBData, setLayoutBData] = useState(null);
  const [layoutCData, setLayoutCData] = useState(null);
  // const [layoutDData, setLayoutDData] = useState(null);

  useEffect(() => {
    setLayoutAData(queryResults[0]?.data?.data);
  }, [queryResults[0]?.isLoading]);

  useEffect(() => {
    setLayoutBData(queryResults[1]?.data?.data);
    // setLayoutCData(queryResults[2]?.data?.data);
  }, [queryResults[1]?.isLoading]);

  useEffect(() => {
    setLayoutCData(queryResults[2]?.data?.data);
  }, [queryResults[2]?.isLoading]);

  // useEffect(() => {
  //   setLayoutDData(queryResults[3]?.data?.data);
  // }, [queryResults[3]?.isLoading]);

  return (
    <>
      <GridWrapper>
        <GridContainer zonaD={currentConfig?.LayoutZonaD}>
          <ZoneA rows={forZonaAFr}>
            {layoutAData ? layoutAData?.map((element) => {
              return renderComponent(element)
            }) : null}
          </ZoneA>
          <ZoneB>
            {/* <MapsWidget /> */}
            {layoutBData ? layoutBData?.map((element) => {
              return renderComponent(element)
            }) : null}
          </ZoneB>
          <ZoneC>
            {layoutCData ? layoutCData?.map((element) => {
              return renderComponent(element)
            }) : null}
          </ZoneC>
          {currentConfig?.LayoutZonaD ? <ZoneD>
          {
          // layoutDData ? 
          currentConfig?.LayoutZonaD.map((element) => {
            return renderComponent(element)
          })
          //  : null
           }
        </ZoneD> : null}

        </GridContainer>
      </GridWrapper>
    </>
  );
}

export default LayoutDefault;